import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import Tab from '@lwt-helix/tab';
import Dashboard from './Dashboard';
import { overviewStatusKeys as keys } from '../constants/listingViews/overview';
import { getMarketIndicatorContent, settingsByTab } from '../helpers/dashboard';
import { useMarketDynamicsStore } from '../../store/marketDynamics/store';

export const OverviewTabs = ({ renderChart, chartData, totalsResult }) => {

    const {
        overviewStatus,
        setOverviewStatusKey,
        marketIndicatorContent,
        setMarketIndicatorContent,
    } = useMarketDynamicsStore(state => ({
        overviewStatus: state.overviewStatus,
        setOverviewStatusKey: state.setOverviewStatusKey,
        marketIndicatorContent: state.marketIndicatorContent,
        setMarketIndicatorContent: state.setMarketIndicatorContent,
    }));

    useEffect(() => {
        setMarketIndicatorContent(getMarketIndicatorContent(totalsResult?.ucAvgDom));
    },[totalsResult]);

    const tabItems = Object.keys(settingsByTab).map((key, index) => ({
        title: key,
        content: {
            jsx: <div className='pt-3'>{renderChart(index)}</div>
        }
    }));

    return (
        <div className='flex-grow-0'>
            <Tab
                tabTextTransform='none'
                navSize={2}
                contentSize={2}
                className='secondary'
                items={tabItems}
                tabs
                currentIndex={overviewStatus.currentTab}
                setCurrentIndex={(index) => setOverviewStatusKey(keys.currentTab, index)}
            />
            <div className='content text-center'>
                <h3 className='mb-4'>{marketIndicatorContent.title}</h3>
                <p>{marketIndicatorContent.description}</p>
            </div>
            <Dashboard currentTab={tabItems[overviewStatus.currentTab]} chartData={chartData}/>
        </div>
    );
};

OverviewTabs.propTypes = {
    chartData: PropTypes.array,
    renderChart: PropTypes.func,
    totalsResult: PropTypes.object,
};
